import React, { useState } from 'react';
import axios from 'axios';

import { BrowserRouter, Route, Routes, Link, useNavigate, Navigate } from 'react-router-dom';

import {LoginManager, LoginManagerWrapper} from "../../../common/api/APIUtils"

const LoginForm = () => {
  //const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    //navigate("/login")
    //LoginManagerWrapper(username, password);
  };

  return (
    <form onSubmit={handleSubmit}>
      <input
        type="text"
        required
        id="username"
        placeholder="ユーザー名"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
      />
      <input
        type="password"
        required
        id="password"
        placeholder="パスワード"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <button type="submit">ログイン</button>
    </form>
  );
};

export default LoginForm;
